import { FormEvent, useEffect, useState } from "react";
import Nav from "../../components/nav";
import "./reset-password.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGlobalState } from "../../global-state-context";
import { Button } from "@mui/material";
import Firebase from "../../api/firebase.class";
import { Aviso, useAviso } from "../../components/aviso-da-tela";

export default function ResetPassword() {
  const navigate = useNavigate();
  const globalState = useGlobalState();
  const [searchParams] = useSearchParams();

  const [isAwaitingAsyncEvent, setIsAwaitingAsyncEvent] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // T8.15 · esta tela é a "recuperação" que o achado nomeia, e ela tinha seis `alert()`.
  const { aviso, erro, sucesso, limpar: limparAviso } = useAviso();

  const mode = searchParams.get("mode");
  const oobCode = searchParams.get("oobCode");

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (isAwaitingAsyncEvent || !oobCode) return;
    limparAviso();

    if (password !== confirmPassword) {
      erro("As duas senhas estão diferentes. Confira e digite de novo.");
      return;
    }

    setIsAwaitingAsyncEvent(true);
    Firebase.resetPassword(oobCode, password)
      .then(() => {
        sucesso("Pronto, a sua senha foi trocada. Agora dá para entrar com ela.");
        navigate("/login");
      })
      .catch((err) => {
        console.log(err.code);
        switch (err.code) {
          case "auth/invalid-action-code":
            // "Codigo invalido ou expirado" descreve o problema e nao a saida. O link de recuperacao
            // expira, e o que a pessoa precisa saber e que dá para pedir outro.
            erro(
              "Este link de recuperação já expirou. Volte à tela de entrar e peça outro e-mail de " +
                "recuperação — o novo link chega em instantes."
            );
            break;
          case "auth/too-many-requests":
            erro("Você tentou muitas vezes seguidas. Espere alguns minutos e tente de novo.");
            break;
          default:
            erro("Não deu para trocar a senha agora. Tente de novo em instantes.");
            break;
        }
      })
      .finally(() => {
        setIsAwaitingAsyncEvent(false);
      });
  }

  useEffect(() => {
    if (!globalState) return;

    if (globalState.authUser?.emailVerified) {
      navigate("/meus-quadrinhos");
    } else if (mode === "verifyEmail") {
      // Ticket 0055 — a URL de ação do console aponta para cá, e a confirmação de e-mail ia para a
      // página genérica do Firebase, em inglês e sem volta. Agora segue para /verificar, no tema.
      navigate(`/verificar${window.location.search}`, { replace: true });
    } else if (mode !== "resetPassword" || !oobCode) {
      navigate("/");
    }
  }, [navigate, globalState, mode, oobCode]);

  if (
    globalState?.authUser?.emailVerified ||
    mode !== "resetPassword" ||
    !oobCode
  ) {
    return <></>;
  }

  return (
    <div className="reset-password-container">
      <Nav />

      <form onSubmit={handleSubmit}>
        <h1>Redefinição de Senha</h1>

        <div className="field-container">
          <label htmlFor="senha">Nova Senha</label>
          <input
            id="senha"
            type="password"
            required
            minLength={6}
            maxLength={15}
            value={password}
            onChange={(event) => setPassword(event.target.value.trim())}
          />
        </div>
        <div className="field-container">
          <label htmlFor="senha">Confirmar Senha</label>
          <input
            id="confirmar-senha"
            type="password"
            required
            minLength={6}
            maxLength={15}
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value.trim())}
          />
        </div>

        <Aviso aviso={aviso} />

        <div className="buttons-container">
          <Button
            variant="contained"
            type="submit"
            disabled={isAwaitingAsyncEvent}
          >
            Salvar
          </Button>
        </div>
      </form>
    </div>
  );
}
